import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { DirectionForm } from './forms/DirectionForm';
import { ParameterSpaceForm } from './forms/ParameterSpaceForm';
import { morphingDirectionState, morphingParameterState } from 'features/morphing/state/stageParameterAtoms';

interface Props {
  subtitle: string;
}

export const MorphingParametersForm: React.FC<Props> = ({ subtitle }) => {
  return (
    <Accordion sx={{ backgroundColor: '#404040', color: '#333' }}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="cfd-content"
        id="cfd-header"
      >
        <CustomTypography >{subtitle}</CustomTypography>
      </AccordionSummary>
      <AccordionDetails>
        <Box component="div">
          <DirectionForm
            directionState={morphingDirectionState}
            label={"Direction"}
          />
        </Box>
        <Box component="div">
          <ParameterSpaceForm
            parameterSpaceState={morphingParameterState}
            label={"Parameter"}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
